import {
  Offer,
  ProgressBarPoint,
  RollingSequenceProduct
} from 'common/contracts';
import { resolveProgressBarPoints } from 'views/Offers/utils/resolveProgressBarPoints';

export type ResolvedProgressBarPoints = ReturnType<
  typeof resolveProgressBarPoints
>;

export const enrichProgressBarPoints = (
  rawPoints: ProgressBarPoint[] | undefined,
  progressBarOffers: Offer[]
): ResolvedProgressBarPoints | undefined => {
  if (!rawPoints || rawPoints.length === 0) return undefined;
  const first = rawPoints[0];
  return resolveProgressBarPoints({
    progressBarId: first.barId === undefined ? null : first.barId,
    points: first.points === undefined ? null : first.points,
    progressBarOffers
  });
};

export const deriveQuantityDisplay = (
  product: RollingSequenceProduct
): string | undefined => {
  const existing = product?.quantityDisplay;
  if (existing !== undefined) return existing;
  const quantity = product?.quantity;
  if (quantity === undefined || quantity === '') return undefined;
  return String(quantity);
};

export const mapSequenceProduct = (productItem: RollingSequenceProduct) => ({
  ...productItem,
  ...productItem?.product,
  quantityDisplay: deriveQuantityDisplay(productItem),
  images: {
    product:
      productItem?.product?.images?.find((img) => img.type === 'product')
        ?.url ||
      productItem?.product?.images?.[0]?.url ||
      null
  }
});
